import { MethodOfReception } from 'bus/methodOfReception/types';

export const METHOD_OF_RECEPTION_INIT_FORM: MethodOfReception = {
  requestId: 0,
  type: null,
  transportId: null,
  driverId: null,
  pumpPhone: '',
  pumpPrice: 0,
  pumpPriceMinimal: 0,
  pumpDelivery: null,
  pumpTotal: null,
  pumpQuantity: 0,
  glassConcretePrice: null,
  comment: '',
  pumpMovingCount: 0,
  pumpPipesCount: 0,
  downtimeHours: 0,
  useQuencher: false,
  pumpQuencherFilledManually: false,
  pumpInningsFilledManually: false,
  pumpMovingFilledManually: false,
  pumpPipesFilledManually: false,
  downtimeFilledManually: false,
  pumpDeliveryFilledManually: false,
  distance: 0,
  driverIds: [],
};
